import ItemMais from "assets/svg/ItemMais";
import Ananas from "assets/svg/Ananas";
import Manioc from "assets/svg/Manioc";
import Igname from "assets/svg/Igname";
import Legumes from "assets/svg/Legumes";
import Carottes from "assets/svg/Carottes";
import Choux from "assets/svg/Choux";
import Orange from "assets/svg/Orange";
import Mangues from "assets/svg/Mangues";
import Cotton from "assets/svg/Cotton";
import PommeDeTerre from "assets/svg/PommeDeTerre";
import Vegetables from "assets/svg/Vegetables";
import { type } from "@testing-library/user-event/dist/type";

export const crops = [
  {
    label: "Maïs",
    imgSrc: <ItemMais />,
  },
  {
    label: "Rïz",
    imgSrc: <Vegetables />,
  },
  {
    label: "Ananas",
    imgSrc: <Ananas />,
  },
  {
    label: "Manioc",
    imgSrc: <Manioc />,
  },
  {
    label: "Igname",
    imgSrc: <Igname />,
  },
  {
    label: "Patate douce",
    // imgSrc: <PatateDouce />,
  },
  {
    label: "Pomme de terre",
    imgSrc: <PommeDeTerre />,
  },
  {
    label: "Légumes",
    imgSrc: <Legumes />,
  },
  {
    label: "Carottes",
    imgSrc: <Carottes />,
  },
  {
    label: "Choux",
    imgSrc: <Choux />,
  },
  {
    label: "Orange",
    imgSrc: <Orange />,
  },
  {
    label: "Mangues",
    imgSrc: <Mangues />,
  },
  {
    label: "Cotton",
    imgSrc: <Cotton />,
  },
];

export const getCropImage = (key) => {
  const res = crops.filter((item) => item?.label === key);
  return res[0]?.imgSrc;
};

export const getManipulatedData = (arr, property) => {
  return arr?.reduce(function (memo, x) {
    if (!memo[x[property]]) {
      x[property] && (memo[x[property]] = []);
    }
    x[property] && memo[x[property]].push(x);
    return memo;
  }, {});
};

export const getEntriesAndExits = (obj, value, subValue) => {
  console.log(obj, "------------>> obj");
  const arr = [];
  Object?.keys(obj || {}).map((ele, index) => {
    const res = obj?.[ele]
      .filter((e) => e?.type === value || e?.cashTransaction === value)
      .map((f) => f?.["typeData"]);
    const resSorties = obj?.[ele]
      .filter((e) => e?.type === subValue || e?.cashTransaction === subValue)
      .map((f) => f?.["typeData"]);
    arr.push({
      key: ele,
      value: { entries: res || [], exits: resSorties || [] },
    });
  });
  return arr;
};

export const addCommas = (num) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const getTotalCahierCounts = (value, subValue) => {
  let entriesSum = 0;
  let exitsSum = 0;

  // Running the for loop
  for (let i = 0; i < value?.length; i++) {
    entriesSum += parseInt(value[i]?.cost?.replace(",", ""));
  }
  for (let i = 0; i < subValue?.length; i++) {
    exitsSum += parseInt(subValue[i]?.cost?.replace(",", ""));
  }

  return {
    entries: addCommas(entriesSum),
    exits: addCommas(exitsSum),
    total: entriesSum - exitsSum,
  };
};

export const getTotalStockCounts = (value, subValue) => {
  let entriesKgSum = 0;
  let entriesCfaSum = 0;
  let exitsKgSum = 0;
  let exitsCfaSum = 0;

  // Running the for loop
  for (let i = 0; i < value?.length; i++) {
    entriesKgSum += parseInt(value[i]?.amount);
  }
  for (let i = 0; i < value?.length; i++) {
    entriesCfaSum += parseInt(value[i]?.rising?.replace(",", ""));
  }
  for (let i = 0; i < subValue?.length; i++) {
    exitsKgSum += parseInt(subValue[i]?.amount);
  }
  for (let i = 0; i < subValue?.length; i++) {
    exitsCfaSum += parseInt(subValue[i]?.rising?.replace(",", ""));
  }
  return {
    entries: { kg: entriesKgSum, cfa: addCommas(entriesCfaSum) },
    exits: { kg: exitsKgSum, cfa: addCommas(exitsCfaSum) },
    total: {
      kg: entriesKgSum - exitsKgSum,
      cfa: addCommas(entriesCfaSum - exitsCfaSum),
    },
  };
};
